import { Button, Card, Col, Collapse, Divider, Dropdown, Form, Input, Image, Menu, Modal, Popconfirm, Popover, Radio, Row, Select, Spin, Switch, TimePicker, Tooltip, notification, Checkbox } from 'antd';
import * as Api from 'api';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { optionsDC2B } from '../options';
import classes from './style.module.scss';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const format = 'HH:mm';

const CameraRemoteAdvanced = ({ IMEI, setting, onChange, onSend, device }) => {
  const [form] = Form.useForm();
  const [password, setPassword] = useState('');
  const [videoLength, setVideoLength] = useState('3');
  const [loading, setLoading] = useState(false);
  const [switchPir, setSwitchPir] = useState(true);
  const [workTimer1, setWorkTimer1] = useState(true);
  const [workTimer2, setWorkTimer2] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalPasswordOpen, setIsModalPasswordOpen] = useState(false);
  const [isModalPlayVideo, setIsModalPlayVideo] = useState(false);
  const [isModalFormat, setIsModalFormat] = useState(false);
  const [isModalReset, setIsModalReset] = useState(false);
  const [formatType, setFormatType] = useState('internal');
  const [switchPassword, setSwitchPassword] = useState(false);
  const [isInActionshot, setIsInActionshot] = useState(false);

  const [pendingPicSizeValue, setPendingPicSizeValue] = useState(null);
  const [confirmPicSizeVisible, setConfirmPicSizeVisible] = useState(false);
  const [pendingTransmittedValue, setPendingTransmittedValue] = useState(null);
  const [confirmTransmittedVisible, setConfirmTransmittedVisible] = useState(false);

  const handleConfirmPicSize = () => {
    form.setFieldsValue({ pic_size: pendingPicSizeValue });
    setConfirmPicSizeVisible(false);
    onChangeForm(form.getFieldsValue());
  };

  const handleCancelPicSize = () => {
    setPendingPicSizeValue(null);
    setConfirmPicSizeVisible(false);
  };

  const handleSelectChangePicSize = (value) => {
    setPendingPicSizeValue(value);
    setConfirmPicSizeVisible(true);
  };

  const handleConfirmTransmitted = () => {
    form.setFieldsValue({ image_transmitted: pendingTransmittedValue });
    setConfirmTransmittedVisible(false);
    onChangeForm(form.getFieldsValue());
  };

  const handleCancelTransmitted = () => {
    setPendingTransmittedValue(null);
    setConfirmTransmittedVisible(false);
  };

  const handleSelectChangeTransmitted = (value) => {
    setPendingTransmittedValue(value);
    setConfirmTransmittedVisible(true);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (device.firmware_version >= 'GMR2HArF7T2') {
        Api.MC2_ACTIONSHOT_STATE(IMEI).then((res: any) => {
          const data = JSON.parse(res.text);
          if (data.result == 'OK') {
            setIsInActionshot(data.status == 'actionshot_start');
          }
        }).catch((error: any) => {
          setLoading(false);
          console.log('error ===>', error);
        });
      }
    }, 2000); // run every 2 second

    return () => clearInterval(interval); // cleanup on unmount
  }, [device]);

  useEffect(() => {
    if (setting) {
      console.log('setting check:', setting);
      let pir_interval_value = setting.pir_interval;
      if (pir_interval_value == 'OFF') {
        setSwitchPir(false);
        pir_interval_value = moment('00:00:00', 'HH:mm:ss');
      } else {
        setSwitchPir(true);
        pir_interval_value = moment(pir_interval_value, 'HH:mm:ss');
      }
      let work_timer_1_value = [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')];
      if (setting.work_timer_1 == 'OFF') {
        setWorkTimer1(false);
      } else {
        setWorkTimer1(true);
        const work_time = setting.work_timer_1.split('-');
        work_timer_1_value = [moment(work_time[0], 'HH:mm'), moment(work_time[1], 'HH:mm')];
      }
      let work_timer_2_value = [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')];
      if (setting.work_timer_2 == 'OFF') {
        setWorkTimer2(false);
      } else {
        setWorkTimer2(true);
        const work_time = setting.work_timer_2.split('-');
        work_timer_2_value = [moment(work_time[0], 'HH:mm'), moment(work_time[1], 'HH:mm')];
      }

      const gps_switch = (setting.gps_on == 1);
      console.log(setting.gps_on);
      console.log(gps_switch);

      form.setFieldsValue({ ...setting, pir_interval_value, work_timer_1_value, work_timer_2_value, gps_switch: (setting.gps_on == 1) });
    }
  }, [setting]);

  // useEffect(() => {
  // onChangeForm();
  // }, [switchPir, workTimer1, workTimer2]);

  const onChangeForm = (values) => {
    // const values = form.getFieldsValue();
    const updatedSetting = {};
    for (let [key, value] of Object.entries(values)) {
      if (key == 'work_timer_1_value') {
        console.log(value);
        key = 'work_timer_1';
        if (value && workTimer1) {
          const time1 = values.work_timer_1_value[0].format(format);
          const time2 = values.work_timer_1_value[1].format(format);
          value = `${time1}-${time2}`;
        } else {
          value = 'OFF';
        }
      } else if (key == 'work_timer_2_value') {
        key = 'work_timer_2';
        if (value && workTimer2) {
          const time1 = values.work_timer_2_value[0].format(format);
          const time2 = values.work_timer_2_value[1].format(format);
          value = `${time1}-${time2}`;
        } else {
          value = 'OFF';
        }
      } else if (key == 'pir_interval_value') {
        key = 'pir_interval';
        if (value && switchPir) {
          value = values.pir_interval_value.format('HH:mm:ss');
        } else {
          value = 'OFF';
        }
      } else if (key == 'gps_switch') {
        key = 'gps_on';
        value = (value ? 1 : 0);
      }
      updatedSetting[key] = value;
      key = '';
    }
    onChange(updatedSetting);
  };

  const onFinish = () => {
    onSend();
  };

  const http_sendcommand = (cmd, param) => {
    const params = {
      IMEI,
      command: cmd,
      param,
    };
    setLoading(true);
    Api.DC2B_SEND_COMMAND(params).then((res: any) => {
      setLoading(false);
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        notification.open({
          message: data.message,
        });
      } else {
        notification.open({
          message: res.text,
          duration: 10,
        });
      }
    }).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const onFirmwareUpdate = () => {
    setIsModalOpen(true);
  };

  const http_formware_update = () => {
    setIsModalOpen(false);
    const params = {
      IMEI,
    };
    setLoading(true);
    Api.DC2B_FIRMWARE_UPDATE(params).then((res: any) => {
      setLoading(false);
      const data = JSON.parse(res.text);
      if (data.result == 'OK') {
        const date = new Date(data.estimated_time * 1000).toLocaleString();
        const confirm_message = `Your update request has been sent to the camera and should be completed by ${date}. Please check back at that time.`;
        notification.open({
          message: confirm_message,
        });
      } else {
        notification.open({
          message: data.message,
          duration: 10,
        });
      }
    }).catch((error: any) => {
      setLoading(false);
      console.log('error ===>', error);
    });
  };

  const on_play_video = () => {
    setIsModalPlayVideo(false);
    http_sendcommand('actionshot', videoLength);
  };

  const on_format = (e) => {
    setIsModalFormat(false);
    http_sendcommand('format', formatType);
  };

  const onReset = () => {
    http_sendcommand('reset', '');
  };

  const on_password = () => {
    let value = password;
    if (!switchPassword || value == '') {
      value = 'OFF';
    } else if (value.length < 6 && value.length > 0) {
      return;
    }
    setIsModalPasswordOpen(false);
    http_sendcommand('password', value);
  };

  return (
    <Spin spinning={loading} size="large">
      <Collapse defaultActiveKey={[]}>
        <Collapse.Panel header="Advanced Settings" key="1">
          <Form
            {...layout}
            form={form}
            name="advanced"
            onValuesChange={(changedValues, allValues) => {
              console.log('all values', allValues);
              onChangeForm(allValues);
            }}
            onFinish={onFinish}
          >
            <Row>
              <Col md={12} xs={24}>
                <Form.Item
                  label="Burst Interval"
                  name="burst_interval"
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsDC2B.BurstInterval}
                  />
                </Form.Item>
                <Form.Item
                  label="IR Flash"
                  name="flash_distance"
                  tooltip={{ title: 'Choose how much flash you wish to use for night time pictures. Low power is better for close subjects. High power tends to wash out close subjects. Low power will reduce visible range in the pictures.', placement: 'bottom' }}
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsDC2B.IRFlash}
                  />
                </Form.Item>
                <Form.Item
                  label="Motion Sensor"
                  name="pir_switch"
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsDC2B.PirSwitch}
                  />
                </Form.Item>
                <Form.Item
                  label="Picture Size"
                  name="pic_size"
                  tooltip={{ title: 'This is the size of the picture that is saved on the SD Card. This will not affect the size of the images transmitted to HuntControl.', placement: 'bottom' }}
                >
                  <Popconfirm
                    title={(
                      <div>
                        This will not affect the physical size of the images transmitted to HuntControl.<br />
                        This only directly affects the size of the image saved to the memory of the camera.<br />
                        It can cause the images to use more data, and may affect your data usage.<br />
                        Do you wish to proceed with the change?
                      </div>
                    )}
                    visible={confirmPicSizeVisible}
                    onConfirm={handleConfirmPicSize}
                    onCancel={handleCancelPicSize}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Select
                      className={classes.control}
                      size="large"
                      onChange={handleSelectChangePicSize}
                      value={form.getFieldValue('pic_size')}
                      options={optionsDC2B.PictureSize}
                    />
                  </Popconfirm>
                </Form.Item>
                <Form.Item
                  label="Image Transmitted"
                  name="image_transmitted"
                  hidden={device.show_transmitted == 0}
                >
                  <Popconfirm
                    title={(
                      <div>
                        This will change the physical size of the images sent to HuntControl.<br />
                        If you change to larger, you will use more data per image transmitted which will decrease your data faster<br />
                        It can cause the images to use more data, and may affect your data usage.<br />
                        Do you wish to proceed?
                      </div>
                    )}
                    visible={confirmTransmittedVisible}
                    onConfirm={handleConfirmTransmitted}
                    onCancel={handleCancelTransmitted}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Select
                      className={classes.control}
                      size="large"
                      onChange={handleSelectChangeTransmitted}
                      value={form.getFieldValue('image_transmitted')}
                      options={optionsDC2B.ImageTransmitted}
                    />
                  </Popconfirm>
                </Form.Item>
                <Form.Item
                  label="Color Mode"
                  name="color_mode"
                  hidden={device.firmware_version < 'GMR2HArF7T2'}
                >
                  <Select
                    className={classes.control}
                    size="large"
                    options={optionsDC2B.ColorMode}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="Verizon Priority:"
                  valuePropName="checked"
                  name="verizon_switch"
                >
                  <Switch
                    size="default"
                  />
                </Form.Item> */}
              </Col>
              <Col md={12} xs={24}>
                <Form.Item
                  label="GPS:"
                  valuePropName="checked"
                  name="gps_switch"
                >
                  <Switch
                    size="default"
                  />
                </Form.Item>
                <Form.Item
                  label="Time Lapse:"
                  className={classes.divTimeLapse}
                  tooltip={{ title: 'Allows you to take pictures at an interval, regardless of the motion sensor. You can set the interval as low as 5 seconds or as high as 23 hrs and 59 minutes. Turning on Time Lapse will disable your motion sensor. If you want the camera to be triggered by motion, make sure the Time Lapse is not enabled.', placement: 'bottom' }}
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="pir_interval_value"
                    >
                      <TimePicker
                        className={classes.control}
                        size="large"
                        disabled={!switchPir}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={switchPir}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          if (checked) {
                            form.setFieldsValue({ pir_interval_value: moment('00:00:03', 'HH:mm:ss') });
                          }
                          setSwitchPir(checked);
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  label="Work Timer1"
                  className={classes.divTimeLapse}
                  tooltip={{ title: 'Select which hours during the day that you would like the camera to be active. Do not set this if you wish the camera to always be active.', placement: 'bottom' }}
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="work_timer_1_value"
                    >
                      <TimePicker.RangePicker
                        className={classes.control}
                        size="large"
                        disabled={!workTimer1}
                        format={format}
                        order={false}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={workTimer1}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          if (checked) {
                            form.setFieldsValue({ work_timer_1_value: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')] });
                          }
                          setWorkTimer1(checked);
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  label="Work Timer2"
                  className={classes.divTimeLapse}
                  tooltip={{ title: 'Select which hours during the day that you would like the camera to be active. Do not set this if you wish the camera to always be active.', placement: 'bottom' }}
                >
                  <Input.Group compact>
                    <Form.Item
                      label=""
                      name="work_timer_2_value"
                    >
                      <TimePicker.RangePicker
                        className={classes.control}
                        size="large"
                        disabled={!workTimer2}
                        format={format}
                        order={false}
                      />
                    </Form.Item>
                    &nbsp;
                    <Form.Item
                      label=""
                    >
                      <Switch
                        checked={workTimer2}
                        onChange={(checked) => {
                          console.log(`switch to ${checked}`);
                          if (checked) {
                            form.setFieldsValue({ work_timer_2_value: [moment('00:00', 'HH:mm'), moment('00:00', 'HH:mm')] });
                          }
                          setWorkTimer2(checked);
                        }}
                      />
                    </Form.Item>
                  </Input.Group>
                </Form.Item>
              </Col>
            </Row>
            <>
              <div className={classes.divFooter}>
                <Button type="primary" htmlType="submit">
                  Send
                </Button>
              </div>
              <Divider />
              <div className={classes.divBottom}>
                <div className={classes.divLine}>
                  <Button type="primary" disabled={device.is_last_firmware} onClick={onFirmwareUpdate}>
                    Camera Firmware Update
                  </Button>
                </div>
                <div className={classes.divLine}>
                  <Button type="primary" onClick={() => setIsModalReset(true)}>
                    Reset
                  </Button>
                </div>
                <div className={classes.divLine}>
                  <Button type="primary" onClick={() => http_sendcommand('get_gps', '')}>
                    Request GPS Position
                  </Button>
                </div>
                <div className={classes.divLine} style={{ display: isInActionshot ? 'none' : '' }}>
                  <Button type="primary" onClick={() => setIsModalPlayVideo(true)}>
                    ActionShot
                  </Button>
                </div>
                <div className={classes.divLine} style={{ display: isInActionshot ? '' : 'none' }}>
                  <div>
                    <Image preview={false} src="/icons/img_icon_as.png" width={80} height={80} />
                    <p>In Progress</p>
                  </div>
                </div>
                <div className={classes.divLine}>
                  <Button type="primary" onClick={() => setIsModalFormat(true)}>
                    Format
                  </Button>
                </div>
                <div className={classes.divLine}>
                  <Button type="primary" onClick={() => setIsModalPasswordOpen(true)}>
                    Password
                  </Button>
                </div>
              </div>
            </>
          </Form>
          <Modal title="" visible={isModalReset} onCancel={() => { setIsModalReset(false); }} onOk={() => { setIsModalReset(false); onReset(); }} okText="Reset">
            <p>The reset command can resolve many common issues with the camera. Only use if you are having trouble with your camera. This will remove all of your settings from the camera. Do you wish to proceed?</p>
          </Modal>
          <Modal title="ActionShot" visible={isModalPlayVideo} onCancel={() => { setIsModalPlayVideo(false); }} onOk={on_play_video}>
            <p>ActionShot videos are too large to be sent over cellular, please retrieve your video from the SD card or internal memory of the camera. If you have an SD card in the camera, the video should be on the SD card.</p>
            <Radio.Group value={videoLength} onChange={(arg) => setVideoLength(arg.target.value)}>
              <Radio.Button value="3">3 minutes</Radio.Button>
              <Radio.Button value="4">4 minutes</Radio.Button>
              <Radio.Button value="5">5 minutes</Radio.Button>
            </Radio.Group>
          </Modal>
          <Modal title="" visible={isModalFormat} onCancel={() => { setIsModalFormat(false); }} okText="Format" onOk={on_format}>
            <p>{`This will remove all files from the ${formatType == 'internal' ? 'internal memory' : 'SD Card'} inside the camera. You will not be able to retrieve the files from the camera. This will not affect images that are already in HuntControl. This will not affect any settings on the camera.`}</p>
            <Radio.Group defaultValue="internal" onChange={(arg) => setFormatType(arg.target.value)}>
              <Radio.Button value="internal">Internal Memory</Radio.Button>
              <Radio.Button value="sd">SD Card</Radio.Button>
            </Radio.Group>
          </Modal>
          <Modal title="" visible={isModalOpen} onOk={http_formware_update} onCancel={() => { setIsModalOpen(false); }}>
            <p>The update may take up to 48hrs to complete. During this time you will be unable to send additional remote control commands. The camera will have to have sufficient battery power and signal for the update to complete properly. After the update, your camera will revert to the default values for all settings. Your camera will continue to send images during the update process. None of your images or data will be affected during the update. Do you wish to proceed?</p>
          </Modal>
          <Modal title="" visible={isModalPasswordOpen} onOk={on_password} onCancel={() => { setIsModalPasswordOpen(false); }}>
            <Form
              {...layout}
              name="basic"
            >
              <Form.Item
                label="Password"
                style={{ marginBottom: 0 }}
              >
                <Input.Group compact>
                  <Form.Item
                    label=""
                    name="password"
                    style={{ marginBottom: 0 }}
                    rules={[
                      {
                        pattern: new RegExp('^[0-9]{6,6}$'),
                        message: 'It must be a 6-digit.',
                      },
                    ]}
                  >
                    <Input
                      maxLength={6}
                      placeholder="OFF"
                      type="password"
                      disabled={!switchPassword}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </Form.Item>
                  &nbsp;
                  <Form.Item
                    label=""
                    style={{ marginBottom: 0 }}
                  >
                    <Switch
                      checked={switchPassword}
                      onChange={(checked) => {
                        console.log(`switch to ${checked}`);
                        setSwitchPassword(checked);
                        if (!checked) {
                          setPassword('');
                        }
                      }}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Form>
          </Modal>
        </Collapse.Panel>
      </Collapse>
    </Spin>
  );
};

export default CameraRemoteAdvanced;
